var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "user-page" } },
    [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "title" } }, [
        _c("div", { staticClass: "col-1" }, [
          _c(
            "svg",
            {
              staticClass: "bd-placeholder-img mr-2 rounded",
              attrs: {
                id: "header",
                width: "28",
                height: "28",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false",
                role: "img",
                "aria-label": "Placeholder: 32x32",
              },
            },
            [
              _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
              }),
            ]
          ),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "col-3" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-info",
              attrs: { id: "backBtn", type: "button" },
              on: { click: _vm.back },
            },
            [_vm._v("キャンセルする")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row", attrs: { id: "register_form" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-8" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.register.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(1),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contact.contactName,
                          expression: "contact.contactName",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "40",
                        autocomplete: "off",
                        placeholder: "連絡先名（必須）",
                        required: "",
                      },
                      domProps: { value: _vm.contact.contactName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.contact,
                            "contactName",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _vm._m(2),
                  _c("div", { staticClass: "col-9" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contact.contactKana,
                          expression: "contact.contactKana",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        maxlength: "80",
                        autocomplete: "off",
                        placeholder: "ふりがな（必須）",
                        required: "",
                      },
                      domProps: { value: _vm.contact.contactKana },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.contact,
                            "contactKana",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._l(_vm.phoneNumbers, function (phoneNumber, index) {
                return _c(
                  "div",
                  { key: `phoneNumber-${index}`, staticClass: "form-group" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c("label", [_vm._v("番号" + _vm._s(index + 1))]),
                      ]),
                      _c("div", { staticClass: "col-2" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: phoneNumber.type,
                                expression: "phoneNumber.type",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  phoneNumber,
                                  "type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "1", selected: "" } },
                              [_vm._v("内線")]
                            ),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v("外線"),
                            ]),
                            _c("option", { attrs: { value: "3" } }, [
                              _vm._v("ダイヤルイン"),
                            ]),
                            _c("option", { attrs: { value: "4" } }, [
                              _vm._v("FAX"),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: phoneNumber.phoneNumber,
                              expression: "phoneNumber.phoneNumber",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            pattern: "[\\d\\-]*",
                            maxlength: "16",
                            placeholder: "番号（必須）",
                            required: "",
                          },
                          domProps: { value: phoneNumber.phoneNumber },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                phoneNumber,
                                "phoneNumber",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "col-1" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index !== 0,
                                expression: "index !== 0",
                              },
                            ],
                            staticClass: "btn-sm btn-outline-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.remove(index)
                              },
                            },
                          },
                          [_vm._v("×")]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-3" }),
                  _c("div", { staticClass: "col-9" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isMaximum,
                            expression: "!isMaximum",
                          },
                        ],
                        staticClass: "btn-sm btn-outline-info",
                        attrs: { type: "button" },
                        on: { click: _vm.add },
                      },
                      [_vm._v("番号を追加する")]
                    ),
                  ]),
                ]),
              ]),
              _vm._l(_vm.groups, function (group, index) {
                return _c(
                  "div",
                  { key: `group-${index}`, staticClass: "form-group" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-3" }, [
                        _c("label", [_vm._v("グループ" + _vm._s(index + 1))]),
                      ]),
                      _c("div", { staticClass: "col-8" }, [
                        index == 0
                          ? _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: group.groupId,
                                    expression: "group.groupId",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  required: _vm.required ? true : false,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      group,
                                      "groupId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.groupOptions, function (option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.id,
                                    domProps: { value: option.id },
                                  },
                                  [_vm._v(" " + _vm._s(option.groupName) + " ")]
                                )
                              }),
                              0
                            )
                          : _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: group.groupId,
                                    expression: "group.groupId",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { required: "" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      group,
                                      "groupId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.groupOptions, function (option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.id,
                                    domProps: { value: option.id },
                                  },
                                  [_vm._v(" " + _vm._s(option.groupName) + " ")]
                                )
                              }),
                              0
                            ),
                      ]),
                      _c("div", { staticClass: "col-1" }, [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: index !== 0,
                                expression: "index !== 0",
                              },
                            ],
                            staticClass: "btn-sm btn-outline-info",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.removeGroup(index)
                              },
                            },
                          },
                          [_vm._v("×")]
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-3" }),
                  _c("div", { staticClass: "col-9" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isMaximumGroup,
                            expression: "!isMaximumGroup",
                          },
                        ],
                        staticClass: "btn-sm btn-outline-info",
                        attrs: { type: "button" },
                        on: { click: _vm.addGroup },
                      },
                      [_vm._v("グループを追加する")]
                    ),
                  ]),
                ]),
              ]),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn btn-block",
                  attrs: { id: "register_button", type: "submit" },
                },
                [_vm._v("登録する")]
              ),
            ],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("連絡先新規作成")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("連絡先名称")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("label", [_vm._v("ふりがな")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }